function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from "react";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import Button from "react-bootstrap/Button";
import "./ManualTimeEntriesReview.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Loader from "./../Loader/Loader";
import { FilterContext, UserContext } from "../index";
import { GoCalendar } from "react-icons/go";
import { UNREVIEWED_MANUAL_TIME_QUERY, REVIEWED_MANUAL_TIME_QUERY, REVIEW_MANUAL_TASK_MUTATION, GET_REVIEW_MANUAL_TIME_COUNT_QUERY } from "./query";
import { toast } from "react-toastify";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal";
var LIMIT = 20;
var ManualTimeEntriesReview = function ManualTimeEntriesReview(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    organisationUserCount = _React$useContext2.organisationUserCount,
    organisationSettings = _React$useContext2.organisationSettings,
    role = _React$useContext2.role;
  var activeManualTab = props.activeManualTab,
    setUnreviewedTaskCount = props.setUnreviewedTaskCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-review-root"
  }, /*#__PURE__*/React.createElement(ReviewEntries, {
    teamId: teamId,
    organisationId: organisationId,
    organisationUserCount: organisationUserCount,
    location: props.location,
    organisationSettings: organisationSettings,
    activeManualTab: activeManualTab,
    setUnreviewedTaskCount: setUnreviewedTaskCount,
    role: role,
    loginUser: user.userId
  }));
};
var ReviewEntries = function ReviewEntries(props) {
  var _manualTimeCountData$2, _manualTimeCountData$3, _manualTimeCountData$4, _manualTimeCountData$5, _manualTimeCountData$6, _manualTimeCountData$7;
  var teamId = props.teamId,
    organisationId = props.organisationId,
    organisationUserCount = props.organisationUserCount,
    location = props.location,
    organisationSettings = props.organisationSettings,
    activeManualTab = props.activeManualTab,
    setUnreviewedTaskCount = props.setUnreviewedTaskCount,
    role = props.role,
    loginUser = props.loginUser;
  var _React$useState = React.useState("unReviewedTime"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeTab = _React$useState2[0],
    setActiveTab = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    reviewTaskSearchText = _React$useState4[0],
    setReviewTaskSearchText = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUnReviewLoadingMore = _React$useState6[0],
    setUnReviewIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isUnReviewAllLoaded = _React$useState8[0],
    setUnReviewIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isReviewedLoadingMore = _React$useState10[0],
    setReviewedIsLoadingMore = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isReviewedAllLoaded = _React$useState12[0],
    setReviewedIsAllLoaded = _React$useState12[1];
  var _React$useState13 = React.useState(""),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    search = _React$useState14[0],
    setSearch = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    showConformationModal = _React$useState16[0],
    setShowConformationModal = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    reviewedTaskListTemp = _React$useState18[0],
    setReviewedTaskListTemp = _React$useState18[1];
  var _useQuery = useQuery(UNREVIEWED_MANUAL_TIME_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        limit: LIMIT,
        offset: 0,
        searchText: reviewTaskSearchText,
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      // skip: !teamId || !loadPage,
      skip: !teamId
    }),
    unreviewedManualTimeData = _useQuery.data,
    unreviewedManualTimeError = _useQuery.error,
    unreviewedManualTimeLoading = _useQuery.loading,
    unreviewedRefetch = _useQuery.refetch,
    unreviewManualFetchMore = _useQuery.fetchMore;
  var _useQuery2 = useQuery(GET_REVIEW_MANUAL_TIME_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        limit: LIMIT,
        offset: 0,
        searchText: reviewTaskSearchText,
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      // skip: !teamId || !loadPage,
      skip: !teamId
    }),
    manualTimeCountData = _useQuery2.data,
    manualTimeCountError = _useQuery2.error,
    manualTimeCountLoading = _useQuery2.loading,
    manualTimeCountRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(REVIEWED_MANUAL_TIME_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getReviewed = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    reviewedLoading = _useLazyQuery2$.loading,
    reviewedManualTimeData = _useLazyQuery2$.data,
    reviewedManualFetchMore = _useLazyQuery2$.fetchMore;
  useEffect(function () {
    unreviewedRefetch === null || unreviewedRefetch === void 0 ? void 0 : unreviewedRefetch();
  }, [location.key, activeManualTab, teamId]);
  useEffect(function () {
    var _manualTimeCountData$;
    setUnreviewedTaskCount(manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$ = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$ === void 0 ? void 0 : _manualTimeCountData$.unreviewedManualTime);
  }, [manualTimeCountData]);
  useEffect(function () {
    if (activeTab != "unReviewedTime") {
      getReviewed({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          type: activeTab == "approvedTime" ? "approved" : "rejected",
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          teamId: teamId
        }
      });
    }
  }, [teamId]);
  useEffect(function () {
    if (activeTab != "unReviewedTime") {
      getReviewed({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          searchText: reviewTaskSearchText,
          type: activeTab == "approvedTime" ? "approved" : "rejected",
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          teamId: teamId
        }
      });
    }
  }, [reviewTaskSearchText]);
  useEffect(function () {
    if (activeTab === "unReviewedTime") {
      var _unreviewedManualTime, _unreviewedManualTime2;
      setUnReviewIsAllLoaded((unreviewedManualTimeData === null || unreviewedManualTimeData === void 0 ? void 0 : (_unreviewedManualTime = unreviewedManualTimeData.unreviewedManualTime) === null || _unreviewedManualTime === void 0 ? void 0 : _unreviewedManualTime.length) != 0 && (unreviewedManualTimeData === null || unreviewedManualTimeData === void 0 ? void 0 : (_unreviewedManualTime2 = unreviewedManualTimeData.unreviewedManualTime) === null || _unreviewedManualTime2 === void 0 ? void 0 : _unreviewedManualTime2.length) < LIMIT ? true : false);
    } else if (activeTab === "approvedTime") {
      var _reviewedManualTimeDa, _reviewedManualTimeDa2;
      setReviewedIsAllLoaded((reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : (_reviewedManualTimeDa = reviewedManualTimeData.reviewedManualTime) === null || _reviewedManualTimeDa === void 0 ? void 0 : _reviewedManualTimeDa.length) != 0 && (reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : (_reviewedManualTimeDa2 = reviewedManualTimeData.reviewedManualTime) === null || _reviewedManualTimeDa2 === void 0 ? void 0 : _reviewedManualTimeDa2.length) < LIMIT ? true : false);
    } else if (activeTab === "rejectedTime") {
      var _reviewedManualTimeDa3, _reviewedManualTimeDa4;
      setReviewedIsAllLoaded((reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : (_reviewedManualTimeDa3 = reviewedManualTimeData.reviewedManualTime) === null || _reviewedManualTimeDa3 === void 0 ? void 0 : _reviewedManualTimeDa3.length) != 0 && (reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : (_reviewedManualTimeDa4 = reviewedManualTimeData.reviewedManualTime) === null || _reviewedManualTimeDa4 === void 0 ? void 0 : _reviewedManualTimeDa4.length) < LIMIT ? true : false);
    }
  }, [unreviewedManualTimeData === null || unreviewedManualTimeData === void 0 ? void 0 : unreviewedManualTimeData.unreviewedManualTime, reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : reviewedManualTimeData.reviewedManualTime]);
  var handleTabSelect = function handleTabSelect(key) {
    setActiveTab(key);
    if (key == "unReviewedTime") {
      setReviewTaskSearchText(null);
      setSearch("");
      unreviewedRefetch === null || unreviewedRefetch === void 0 ? void 0 : unreviewedRefetch();
    } else if (key === "approvedTime") {
      setReviewTaskSearchText(null);
      setSearch("");
      getReviewed({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          type: "approved",
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          teamId: teamId
        }
      });
    } else if (key === "rejectedTime") {
      setReviewTaskSearchText(null);
      setSearch("");
      getReviewed({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          type: "rejected",
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          teamId: teamId
        }
      });
    }
  };
  var handleConfirmationClose = function handleConfirmationClose() {
    setShowConformationModal(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-2 manual-time-review-usage-root-list"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "unReviewedTime",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "unReviewedTime",
    title: "Unreviewed Time ".concat((manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$2 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$2 === void 0 ? void 0 : _manualTimeCountData$2.unreviewedManualTime) != 0 && !manualTimeCountLoading && !manualTimeCountError ? "(".concat(manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$3 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$3 === void 0 ? void 0 : _manualTimeCountData$3.unreviewedManualTime, ")") : "")
  }, /*#__PURE__*/React.createElement(ReviewEntriesList, {
    name: "unreviewed manual time",
    organisationId: organisationId,
    teamId: teamId,
    activeTab: activeTab,
    list: unreviewedManualTimeData === null || unreviewedManualTimeData === void 0 ? void 0 : unreviewedManualTimeData.unreviewedManualTime,
    loading: unreviewedManualTimeLoading,
    reviewTaskSearchText: reviewTaskSearchText,
    setReviewTaskSearchText: setReviewTaskSearchText,
    unreviewManualFetchMore: unreviewManualFetchMore,
    reviewedManualFetchMore: reviewedManualFetchMore,
    isUnReviewLoadingMore: isUnReviewLoadingMore,
    setUnReviewIsLoadingMore: setUnReviewIsLoadingMore,
    isUnReviewAllLoaded: isUnReviewAllLoaded,
    setUnReviewIsAllLoaded: setUnReviewIsAllLoaded,
    isReviewedLoadingMore: isReviewedLoadingMore,
    setReviewedIsLoadingMore: setReviewedIsLoadingMore,
    isReviewedAllLoaded: isReviewedAllLoaded,
    setReviewedIsAllLoaded: setReviewedIsAllLoaded,
    search: search,
    setSearch: setSearch,
    getReviewed: getReviewed,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    showConformationModal: showConformationModal,
    setShowConformationModal: setShowConformationModal,
    reviewedTaskListTemp: reviewedTaskListTemp,
    role: role,
    loginUser: loginUser
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "approvedTime",
    title: "Approved Time ".concat((manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$4 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$4 === void 0 ? void 0 : _manualTimeCountData$4.approvedManualTime) != 0 && !manualTimeCountLoading && !manualTimeCountError ? "(".concat(manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$5 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$5 === void 0 ? void 0 : _manualTimeCountData$5.approvedManualTime, ")") : "")
  }, /*#__PURE__*/React.createElement(ReviewEntriesList, {
    name: "approved manual time",
    organisationId: organisationId,
    teamId: teamId,
    list: reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : reviewedManualTimeData.reviewedManualTime,
    loading: reviewedLoading,
    reviewTaskSearchText: reviewTaskSearchText,
    setReviewTaskSearchText: setReviewTaskSearchText,
    unreviewManualFetchMore: unreviewManualFetchMore,
    reviewedManualFetchMore: reviewedManualFetchMore,
    isUnReviewLoadingMore: isUnReviewLoadingMore,
    setUnReviewIsLoadingMore: setUnReviewIsLoadingMore,
    isUnReviewAllLoaded: isUnReviewAllLoaded,
    setUnReviewIsAllLoaded: setUnReviewIsAllLoaded,
    isReviewedLoadingMore: isReviewedLoadingMore,
    setReviewedIsLoadingMore: setReviewedIsLoadingMore,
    isReviewedAllLoaded: isReviewedAllLoaded,
    setReviewedIsAllLoaded: setReviewedIsAllLoaded,
    search: search,
    setSearch: setSearch,
    getReviewed: getReviewed,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    reviewedTaskListTemp: reviewedTaskListTemp,
    role: role,
    loginUser: loginUser
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "rejectedTime",
    title: "Rejected Time ".concat((manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$6 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$6 === void 0 ? void 0 : _manualTimeCountData$6.rejectedManualTime) != 0 && !manualTimeCountLoading && !manualTimeCountError ? "(".concat(manualTimeCountData === null || manualTimeCountData === void 0 ? void 0 : (_manualTimeCountData$7 = manualTimeCountData.getReviewManualTimeCount) === null || _manualTimeCountData$7 === void 0 ? void 0 : _manualTimeCountData$7.rejectedManualTime, ")") : "")
  }, /*#__PURE__*/React.createElement(ReviewEntriesList, {
    name: "rejected manual time",
    organisationId: organisationId,
    teamId: teamId,
    activeTab: activeTab,
    list: reviewedManualTimeData === null || reviewedManualTimeData === void 0 ? void 0 : reviewedManualTimeData.reviewedManualTime,
    loading: reviewedLoading,
    reviewTaskSearchText: reviewTaskSearchText,
    setReviewTaskSearchText: setReviewTaskSearchText,
    unreviewManualFetchMore: unreviewManualFetchMore,
    reviewedManualFetchMore: reviewedManualFetchMore,
    isUnReviewLoadingMore: isUnReviewLoadingMore,
    setUnReviewIsLoadingMore: setUnReviewIsLoadingMore,
    isUnReviewAllLoaded: isUnReviewAllLoaded,
    setUnReviewIsAllLoaded: setUnReviewIsAllLoaded,
    isReviewedLoadingMore: isReviewedLoadingMore,
    setReviewedIsLoadingMore: setReviewedIsLoadingMore,
    isReviewedAllLoaded: isReviewedAllLoaded,
    setReviewedIsAllLoaded: setReviewedIsAllLoaded,
    search: search,
    setSearch: setSearch,
    getReviewed: getReviewed,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    reviewedTaskListTemp: reviewedTaskListTemp,
    role: role,
    loginUser: loginUser
  }))), /*#__PURE__*/React.createElement(ReviewConfirmationModal, {
    showConformationModal: showConformationModal,
    handleConfirmationClose: handleConfirmationClose,
    getReviewed: getReviewed,
    manualTimeCountRefetch: manualTimeCountRefetch,
    setReviewedTaskListTemp: setReviewedTaskListTemp
  })));
};
function ReviewEntriesList(props) {
  var list = props.list,
    organisationId = props.organisationId,
    teamId = props.teamId,
    name = props.name,
    loading = props.loading,
    reviewTaskSearchText = props.reviewTaskSearchText,
    setReviewTaskSearchText = props.setReviewTaskSearchText,
    unreviewManualFetchMore = props.unreviewManualFetchMore,
    reviewedManualFetchMore = props.reviewedManualFetchMore,
    activeTab = props.activeTab,
    isUnReviewLoadingMore = props.isUnReviewLoadingMore,
    setUnReviewIsLoadingMore = props.setUnReviewIsLoadingMore,
    isUnReviewAllLoaded = props.isUnReviewAllLoaded,
    setUnReviewIsAllLoaded = props.setUnReviewIsAllLoaded,
    isReviewedLoadingMore = props.isReviewedLoadingMore,
    setReviewedIsLoadingMore = props.setReviewedIsLoadingMore,
    isReviewedAllLoaded = props.isReviewedAllLoaded,
    setReviewedIsAllLoaded = props.setReviewedIsAllLoaded,
    search = props.search,
    setSearch = props.setSearch,
    timezone = props.timezone,
    getReviewed = props.getReviewed,
    showConformationModal = props.showConformationModal,
    setShowConformationModal = props.setShowConformationModal,
    reviewedTaskListTemp = props.reviewedTaskListTemp,
    role = props.role,
    loginUser = props.loginUser;
  function handleUnReviewScroll() {
    if (loading) return;
    if (isUnReviewAllLoaded) return;
    setUnReviewIsLoadingMore(true);
    unreviewManualFetchMore({
      variables: {
        offset: list.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.unreviewedManualTime.length < LIMIT && !isUnReviewAllLoaded) {
          setUnReviewIsAllLoaded(true);
        }
        setUnReviewIsLoadingMore(false);
        var NewFilterData = [];
        fetchMoreResult.unreviewedManualTime.forEach(function (newReviewApp) {
          var found = prev.unreviewedManualTime.find(function (item) {
            return item.manualTaskId === newReviewApp.manualTaskId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newReviewApp);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          unreviewedManualTime: [].concat(_toConsumableArray(prev.unreviewedManualTime), NewFilterData)
        });
      }
    });
    //setLimits(LIMIT + 20);
  }
  function handleReviewedScroll() {
    if (loading) return;
    if (isReviewedAllLoaded) return;
    setReviewedIsLoadingMore(true);
    reviewedManualFetchMore({
      variables: {
        offset: list.length
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.reviewedManualTime.length < LIMIT && !isReviewedAllLoaded) {
          setReviewedIsAllLoaded(true);
        }
        setReviewedIsLoadingMore(false);
        var NewFilterData = [];
        fetchMoreResult.reviewedManualTime.forEach(function (newReviewApp) {
          var found = prev.reviewedManualTime.find(function (item) {
            return item.manualTaskId === newReviewApp.manualTaskId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newReviewApp);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          reviewedManualTime: [].concat(_toConsumableArray(prev.reviewedManualTime), NewFilterData)
        });
      }
    });
    //setLimits(LIMIT + 20);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-review-usage-root-listing"
    // onScroll={(e) => (activeTab == "unReviewedTime" ? handleUnReviewScroll(e) : handleReviewedScroll(e))}
  }, loading ? /*#__PURE__*/React.createElement(Loader, null) : !list || (list === null || list === void 0 ? void 0 : list.length) == 0 ? /*#__PURE__*/React.createElement("p", null, "No data found") : list && list.length ? list.map(function (item, key) {
    var _list;
    var displayName = item.displayName,
      manualTaskId = item.manualTaskId,
      taskDescription = item.taskDescription,
      totalWorkedHours = item.totalWorkedHours,
      taskDate = item.taskDate,
      reviewStatus = item.reviewStatus,
      projectName = item.projectName,
      startTime = item.startTime,
      endTime = item.endTime,
      reviewTeamId = item.teamId,
      reviewedBy = item.reviewedBy,
      userId = item.userId;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key === 0 || !isSameDay(Number((_list = list[key - 1]) === null || _list === void 0 ? void 0 : _list.taskDate), Number(item === null || item === void 0 ? void 0 : item.taskDate)) ? /*#__PURE__*/React.createElement("div", {
      className: "manual-time-date-divider-label-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "manual-time-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(GoCalendar, null)), /*#__PURE__*/React.createElement("span", null, isToday(Number(taskDate)) ? "Today" : isYesterday(Number(taskDate)) ? "Yesterday" : format(Number(taskDate), "d-LLL-yyyy")))) : null, key === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "rounded-lg mb-3 p-2 manual-time-review-usage-root-listing-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1  manual-time-review-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-display-name manual-time-review-column manual-time-review-column-header"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-name"
    }, "Employee Name")), /*#__PURE__*/React.createElement("div", {
      className: "d-flex manual-time-review-task-name manual-time-review-column manual-time-review-column-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 manual-time-review-text-hours"
    }, "Manual Time Description"), /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-text-project-name"
    })), /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column manual-time-review-column-header"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 manual-time-review-text-hours"
    }, "Duration")), /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column manual-time-review-column-header"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 manual-time-review-text-hours"
    }, "Worked Time")), activeTab == "unReviewedTime" ? null : /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column manual-time-review-column-header"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 manual-time-review-text-hours"
    }, "Review Status"))), activeTab == "unReviewedTime" ? /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-button-div"
    }, /*#__PURE__*/React.createElement(ReviewButtons, {
      reviewStatus: reviewStatus,
      showConformationModal: showConformationModal,
      setShowConformationModal: setShowConformationModal,
      manualTaskId: manualTaskId,
      teamId: teamId,
      organisationId: organisationId,
      timezone: timezone,
      reviewedTaskListTemp: reviewedTaskListTemp,
      role: role,
      loginUser: loginUser,
      createdBy: userId
    })) : "") : null, /*#__PURE__*/React.createElement("div", {
      className: " mb-3 manual-time-review-usage-root-listing-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-light p-2 rounded-lg d-flex align-items-center flex-grow-1  manual-time-review-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-display-name manual-time-review-column"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-name"
    }, displayName)), /*#__PURE__*/React.createElement("div", {
      className: "d-flex manual-time-review-task-name manual-time-review-column"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-risk-violation",
        className: "risk-count-tooltip-start"
      }, /*#__PURE__*/React.createElement("span", null, taskDescription))
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 manual-time-review-text-hours"
    }, taskDescription)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-risk-violation",
        className: "risk-count-tooltip-start"
      }, /*#__PURE__*/React.createElement("span", null, projectName))
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-text-project-name"
    }, projectName))), /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column"
    }, totalWorkedHours), /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column"
    }, "".concat(startTime, " - ").concat(endTime)), activeTab == "unReviewedTime" ? null : /*#__PURE__*/React.createElement("div", {
      className: "manual-time-review-hours manual-time-review-column manual-time-review-column-review-status"
    }, "".concat(activeTab == "rejectedTime" ? "Rejected" : "Approved", " by ").concat(reviewedBy))), activeTab == "unReviewedTime" ? /*#__PURE__*/React.createElement(ReviewButtons, {
      reviewStatus: reviewStatus,
      showConformationModal: showConformationModal,
      setShowConformationModal: setShowConformationModal,
      manualTaskId: manualTaskId,
      teamId: teamId,
      organisationId: organisationId,
      timezone: timezone,
      reviewedTaskListTemp: reviewedTaskListTemp,
      reviewTeamId: reviewTeamId,
      role: role,
      loginUser: loginUser,
      createdBy: userId
    }) : ""));
  }) : reviewTaskSearchText ? /*#__PURE__*/React.createElement("div", null, "Your search \"".concat(reviewTaskSearchText, "\" is not found")) : null, !loading && list && (list === null || list === void 0 ? void 0 : list.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, activeTab == "unReviewedTime" && !isUnReviewAllLoaded || activeTab != "unReviewedTime" && !isReviewedAllLoaded ? activeTab == "unReviewedTime" && isUnReviewLoadingMore || activeTab != "unReviewedTime" && isReviewedLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      activeTab == "unReviewedTime" ? handleUnReviewScroll() : handleReviewedScroll();
    },
    className: "review-usage-load-more-button"
  }, "Load More") : !loading && !reviewTaskSearchText && list && list.length != 0 && (activeTab == "unReviewedTime" && isUnReviewAllLoaded || activeTab != "unReviewedTime" && isReviewedAllLoaded) ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the manual time") : null) : null));
}
var ReviewButtons = function ReviewButtons(props) {
  var reviewStatus = props.reviewStatus,
    setShowConformationModal = props.setShowConformationModal,
    manualTaskId = props.manualTaskId,
    teamId = props.teamId,
    organisationId = props.organisationId,
    timezone = props.timezone,
    reviewedTaskListTemp = props.reviewedTaskListTemp,
    reviewTeamId = props.reviewTeamId,
    role = props.role,
    loginUser = props.loginUser,
    createdBy = props.createdBy;
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    status = _React$useState20[0],
    setStatus = _React$useState20[1];
  var handleShow = function handleShow(data) {
    setStatus(data);
  };

  //onChange={(newStatus) => handleReview(newStatus, manualTaskId)}

  return /*#__PURE__*/React.createElement("div", {
    className: "bg-light p-2 rounded-lg review-usage-root-listing-card-button"
  }, role == "Head" && loginUser == createdBy ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-approve-".concat(manualTaskId),
      className: "count-tooltip-start"
    }, "You don't have enough permission to approve/reject.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-success",
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm",
    active: reviewStatus == "approved" || status && status.reviewStatus == "approved" && status.manualTaskId == manualTaskId,
    disabled: true
  }, reviewStatus == "approved" || status && status.reviewStatus == "approved" && status.manualTaskId == manualTaskId ? "Approved" : "Approve")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-success",
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm",
    active: reviewStatus == "approved" || status && status.reviewStatus == "approved" && status.manualTaskId == manualTaskId,
    onClick: function onClick() {
      setShowConformationModal({
        reviewStatus: "approved",
        handleShow: handleShow,
        manualTaskId: manualTaskId,
        teamId: teamId,
        organisationId: organisationId,
        timezone: timezone,
        reviewTeamId: reviewTeamId
      });
    },
    disabled: reviewedTaskListTemp.includes(manualTaskId)
  }, reviewStatus == "approved" || status && status.reviewStatus == "approved" && status.manualTaskId == manualTaskId ? "Approved" : "Approve"), role == "Head" && loginUser == createdBy ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-approve-".concat(manualTaskId),
      className: "count-tooltip-start"
    }, "You don't have enough permission to approve/reject.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    active: reviewStatus == "rejected" || status && status.reviewStatus == "rejected" && status.manualTaskId == manualTaskId,
    disabled: true,
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm"
  }, reviewStatus == "rejected" || status && status.reviewStatus == "rejected" && status.manualTaskId == manualTaskId ? "Rejected" : "Reject")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    active: reviewStatus == "rejected" || status && status.reviewStatus == "rejected" && status.manualTaskId == manualTaskId,
    onClick: function onClick() {
      setShowConformationModal({
        reviewStatus: "rejected",
        handleShow: handleShow,
        manualTaskId: manualTaskId,
        teamId: teamId,
        organisationId: organisationId,
        timezone: timezone,
        reviewTeamId: reviewTeamId
      });
    },
    disabled: reviewedTaskListTemp.includes(manualTaskId) || role == "Head" && loginUser == createdBy,
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm"
  }, reviewStatus == "rejected" || status && status.reviewStatus == "rejected" && status.manualTaskId == manualTaskId ? "Rejected" : "Reject"));
};
export var ReviewConfirmationModal = function ReviewConfirmationModal(props) {
  var showConformationModal = props.showConformationModal,
    handleConfirmationClose = props.handleConfirmationClose,
    getReviewed = props.getReviewed,
    manualTimeCountRefetch = props.manualTimeCountRefetch,
    setReviewedTaskListTemp = props.setReviewedTaskListTemp;
  if (showConformationModal == null) {
    return null;
  }
  var reviewStatus = showConformationModal.reviewStatus,
    handleShow = showConformationModal.handleShow,
    manualTaskId = showConformationModal.manualTaskId,
    teamId = showConformationModal.teamId,
    organisationId = showConformationModal.organisationId,
    timezone = showConformationModal.timezone,
    reviewTeamId = showConformationModal.reviewTeamId;
  var _useMutation = useMutation(REVIEW_MANUAL_TASK_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateReviewManualTaskStatus = _useMutation2[0],
    updateReviewManualTaskStatusLoading = _useMutation2[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reviewStatus, manualTaskId, teamId, reviewTeamId) {
      var _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!updateReviewManualTaskStatusLoading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return updateReviewManualTaskStatus({
              variables: {
                organisationId: organisationId,
                reviewStatus: reviewStatus,
                manualTaskId: manualTaskId,
                teamId: reviewTeamId,
                timezone: timezone
              }
            });
          case 5:
            response = _context.sent;
            if (response && response !== null && response !== void 0 && response.data && (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.updateReviewManualTaskStatus) == true) {
              toast.success("Review status updated successfully!");
              getReviewed({
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0,
                  searchText: null,
                  type: reviewStatus,
                  timezone: timezone,
                  teamId: teamId
                }
              });
              manualTimeCountRefetch === null || manualTimeCountRefetch === void 0 ? void 0 : manualTimeCountRefetch();
              handleConfirmationClose();
              handleShow({
                reviewStatus: reviewStatus,
                manualTaskId: manualTaskId
              });
              setReviewedTaskListTemp(function (oldTask) {
                return [].concat(_toConsumableArray(oldTask), [manualTaskId]);
              });
            } else {
              toast.error("Error, try again!");
            }
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            toast.error("Error, try again!");
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showConformationModal,
    onHide: handleConfirmationClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Review Confirmation")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure to ", reviewStatus == "approved" ? "approve" : "reject", " this task?", " ", /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-delete-body-p-tag"
  }, "This action cannot be undone.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "manual-task-project-details-task-card-delete-cancel-button",
    onClick: handleConfirmationClose
  }, "No"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "manual-task-project-details-task-card-delete-button",
    onClick: function onClick() {
      handleReview(reviewStatus, manualTaskId, teamId, reviewTeamId);
    },
    disabled: updateReviewManualTaskStatusLoading
  }, updateReviewManualTaskStatusLoading ? "Loading..." : "Yes")));
};
export default ManualTimeEntriesReview;